import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const createCartMilestone = (
  cartTag: string,
  milestone: string,
  details?: string | null
): Promise<AxiosResponse> => {
  return jwtApiClient.post(M3_API(cartTag).CREATE_CART_MILESTONE, {
    milestone: milestone,
    details: details || null,
  });
};
